import { Numeric1CircleIcon } from './Numeric1CircleIcon';

/**
 * author: Contributors
 * id 77E2B22B-C6FB-4759-B2BB-0528DAFA6210
 * name numeric-1-circle
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/numeric-1-circle.svg
 * tags
 * - Alpha / Numeric 
 */
export const Number1CircleIcon = Numeric1CircleIcon;
export default Number1CircleIcon